import { ActivatedRouteSnapshot } from '@angular/router';

import { Paths } from '@config/paths.config';

export const PAT_ERROR_MESSAGES = {
  NO_CHECKS_OPEN: `pay-at-table.error.no-checks-open`,
  TRY_AGAIN_LATER: `pay-at-table.error.try-again-later`,
  NOT_FOUND: `pay-at-table.error.location-not-found`,
  CHECK_LOCKED: `pay-at-table.error.table-locked`,
};

export const PAT_ERROR_NO_CHECKS_OPEN = 'No checks are open on this location';
export const PAT_ERROR_NOT_FOUND = 'Not Found';
export const PAT_ERROR_CHECK_LOCKED = 'CHECK_LOCKED';
export const A_LOCK_FAILED_DOCUMENT = 'A lock failed on a document.';

export const CHECK_TIPS_CONFIG = {
  'amount-1': 1,
  'type-1': 'currency',
  'amount-2': 2,
  'type-2': 'currency',
  'amount-3': 3,
  'type-3': 'currency',
};

/** Query param value that activates PAT mock mode (?checkId=test). */
export const PAT_MOCK_CHECK_ID = 'test';

export function isPatMockMode(checkId: string | null | undefined): boolean {
  return checkId === PAT_MOCK_CHECK_ID;
}

/** Query params to preserve when navigating between PAT pages in mock mode. */
export const PAT_MOCK_QUERY_PARAMS = { checkId: PAT_MOCK_CHECK_ID } as const;

/** Reads checkId from the activated route tree (child routes may not expose queryParams on their snapshot). */
export function getPatMockCheckIdFromRoute(route: ActivatedRouteSnapshot): string | null {
  let current: ActivatedRouteSnapshot | null = route;
  while (current) {
    const checkId = current.queryParams['checkId'];
    if (checkId) {
      return checkId;
    }
    current = current.parent;
  }
  return null;
}

export function getPatMockCheckIdFromUrl(): string | null {
  return new URLSearchParams(window.location.search).get('checkId');
}

export function resolvePatMockCheckId(route?: ActivatedRouteSnapshot): string | null {
  return (route ? getPatMockCheckIdFromRoute(route) : null) ?? getPatMockCheckIdFromUrl();
}

export function isPatMockPayAtTableUrl(url: string): boolean {
  return url.includes(`/${Paths.PayAtTable}`);
}
